import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-error",
  "use": "icon-error-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-error\"><path d=\"M7 .333a6.667 6.667 0 1 1 0 13.334A6.667 6.667 0 0 1 7 .333Zm2.357 4.31a.667.667 0 0 0-.943 0L7 6.056 5.586 4.643a.667.667 0 1 0-.943.943l1.414 1.413-1.414 1.415a.667.667 0 1 0 .943.943L7 7.942l1.413 1.415a.667.667 0 1 0 .943-.943L7.943 7l1.414-1.414a.667.667 0 0 0 0-.943Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol